<template>
  <span
    class="indicador-selecao"
    :class="{'indicador-selecao-selecionado': selecionado}"
    :style="dimensoes"
    aria-hidden="true"
  ></span>
</template>

<script>
export default {
  name: 'IndicadorSelecao',
  props: {
    selecionado: {
      type: Boolean,
      default: false
    },
    tamanho: {
      type: [Number, String],
      default: 24
    }
  },
  computed: {
    dimensoes() {
      const tamanho = typeof this.tamanho === 'number' ? `${this.tamanho}px` : this.tamanho;

      return {
        width: tamanho,
        height: tamanho
      };
    }
  }
};
</script>

<style scoped>
.indicador-selecao {
  display: inline-block;
  flex: 0 0 auto;
  border-radius: 50%;
  background-color: #eeeff0;
  box-sizing: border-box;
  vertical-align: middle;
}

.indicador-selecao-selecionado {
  border: 4px solid var(--lecard-primary);
  background-color: transparent;
}
</style>
